import React from "react";
import PropTypes from "prop-types";

import SVG from "../../../components/SVG";
import { Row, Col, Popper } from "../../../components/simple";
import VariableList from "../VariableList";
import { defaultOptions } from "../../../helpers/popoverOptions";

import { formatPercentage } from "../../../helpers/formatter";

import "./style.scss";

export default function PresetPopper(props) {
  const { preset, id, toggle, boundariesElement } = props;
  const variablesGroups = preset.groups.map(group => {
    return {
      ...group,
      variables: group.variables.map(variable => {
        return { ...variable, active: true };
      })
    };
  });

  return (
    <Popper
      popperOptions={{
        className: `${defaultOptions.className} presets-popper`,
        isOpen: id === preset.id,
        target: `preset-popper-${preset.id}`,
        toggle: () => toggle(""),
        boundariesElement
      }}
    >
      <Row className="popper-preset-variables">
        <h5>Selected variables:</h5>
        <VariableList list={variablesGroups} />
      </Row>
      <Row className="popper-preset-stats">
        <Col sm={8} md={8} xl={8}>
          <h5>Reach</h5>
          <Row>
            <Col sm={6} md={6} xl={6} className="stat">
              <span>{preset.populationLl}</span> People
            </Col>
            <Col sm={6} md={6} xl={6} className="stat">
              <span>{preset.reachLl && formatPercentage(preset.reachLl)}</span>{" "}
              Population
            </Col>
          </Row>
        </Col>
        <Col sm={4} md={4} xl={4}>
          <h5>Precision</h5>
          <div className="stat-afinity">
            <div
              className={`status ${
                preset.qualityIndicator
                  ? preset.qualityIndicator.toLowerCase()
                  : ""
              }`}
            />
            <span
              className={`value ${
                preset.qualityIndicator
                  ? preset.qualityIndicator.toLowerCase()
                  : ""
              }`}
            >
              {preset.precisionLl && preset.precisionLl.toFixed(1)}
            </span>{" "}
            Affinity
          </div>
        </Col>
      </Row>
      <Row className="popper-preset-about">
        <Col sm={8} md={8} xl={8} className="pr-3">
          <p className="description">{preset.description}</p>
        </Col>
        <Col sm={4} md={4} xl={4}>
          <h5 className="created-by">Created by:</h5>
          <div className="audience-creator">
            <SVG.Client className="user-icon" />
            <span>{preset.createdBy}</span>
          </div>
        </Col>
      </Row>
    </Popper>
  );
}

PresetPopper.propTypes = {
  preset: PropTypes.shape({
    id: PropTypes.string,
    createdBy: PropTypes.string,
    description: PropTypes.string,
    precisionLl: PropTypes.number,
    reachLl: PropTypes.number,
    populationLl: PropTypes.number,
    groups: PropTypes.arrayOf(
      PropTypes.shape({
        variables: PropTypes.arrayOf(PropTypes.shape({}))
      })
    ),
    qualityIndicator: PropTypes.string
  }).isRequired,
  toggle: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  boundariesElement: PropTypes.oneOfType([PropTypes.string, window.DOMElement])
};

PresetPopper.defaultProps = {
  boundariesElement: null
};
